var EventsFix = {
    $emptyEvent: '',
    $monthTitle: '',
    dateFix: function() {
        if ( ! this.$emptyEvent ) {
            return;
        }

        let new_date = this.$emptyEvent.nextElementSibling.querySelector('.tribe-month-fix').textContent;

        this.$monthTitle.querySelector('span').textContent = new_date;
        this.$emptyEvent.style.display = 'none';
        EventsFix.showTitle();
    },
    showTitle: function() {
        this.$monthTitle.style.display = 'block';
    },
    init: function() {

        this.$emptyEvent = document.getElementById('post-0');
        this.$monthTitle = document.querySelector('.tribe-events-list-separator-month');

        if (EventsFix.$emptyEvent !== null && EventsFix.$monthTitle !== null) {
            EventsFix.dateFix();
        } else if (EventsFix.$monthTitle !== null) {
            EventsFix.showTitle();
        }
    }
}
EventsFix.init();
export default EventsFix;
